/**
 * Central sales configuration.
 *
 * EDITOR NOTE: checkout is NOT connected yet (see docs/editor-notes.md).
 * While `checkoutUrl` is null, every purchase CTA scrolls to #offer and the
 * offer card shows a non-purchasing "Checkout coming soon" control.
 * Set `checkoutUrl` to the real checkout link to connect all CTAs at once.
 *
 * Contact, privacy, terms and refund links only render once a real
 * destination is supplied here.
 */

type SiteConfig = {
  productName: string
  wordmark: string
  price: string
  guaranteeLabel: string
  ctaLabel: string
  checkoutUrl: string | null
  offerCheckoutUrl: string
  refundPolicyUrl: string | null
  supportEmail: string | null
  privacyUrl: string | null
  termsUrl: string | null
  heroImage: string
  seo: {
    title: string
    description: string
  }
}

export const siteConfig: SiteConfig = {
  productName: 'Horse Riding Instructor’s Complete Teaching Toolkit',
  wordmark: 'Horse Riding Instructor’s Toolkit',
  price: 'US$27',
  guaranteeLabel: '7-Day Money-Back Guarantee',
  ctaLabel: 'Get the Complete Toolkit',
  checkoutUrl: null,
  // Only the button inside the offer card links here; other CTAs scroll to #offer.
  offerCheckoutUrl:
    'https://horse-riding-instructors.impultienda.ar/checkout',
  refundPolicyUrl: null,
  supportEmail: null,
  privacyUrl: null,
  termsUrl: null,
  heroImage:
    'https://cdn.magicpatterns.com/uploads/hRRLCgRryDN6C6yE9ngXxX/Imagen_de_Codex_29_sept_2026,_01_47_27_p.m..png',
  seo: {
    title: 'Horse Riding Instructor’s Complete Teaching Toolkit',
    description:
      'Plan purposeful riding lessons with 8 teaching volumes and 5 bonus kits for instructors teaching children, teenagers and adults.',
  },
}
